import React from 'react';
import { cn } from 'lib/utils';

export interface TableContainerProps {
    title?: string;
    resultCount?: number;
    actions?: React.ReactNode;
    children: React.ReactNode;
    className?: string;
}

const TableContainer: React.FC<TableContainerProps> = ({
    title,
    resultCount,
    actions,
    children,
    className = '',
}) => {
    const hasHeader = title || resultCount !== undefined || actions;

    return (
        <div className={cn('rounded border border-border bg-card overflow-hidden', className)}>
            {hasHeader && (
                <div className="flex items-center justify-between gap-4 border-b border-border px-4 py-3">
                    <div className="flex items-center gap-3 min-w-0 whitespace-nowrap">
                        {title && (
                            <h2 className="text-md font-semibold text-foreground truncate">
                                {title}
                            </h2>
                        )}
                        {resultCount !== undefined && (
                            <span className="text-xs text-muted-foreground tabular-nums">
                                총 <span className="font-medium text-foreground">{resultCount}</span>건
                            </span>
                        )}
                    </div>
                    {actions && (
                        <div className="flex items-center gap-2 shrink-0">{actions}</div>
                    )}
                </div>
            )}
            <div className="overflow-x-auto">{children}</div>
        </div>
    );
};

export default TableContainer;
